var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 132,
    viewBox: "0 0 165 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.04904,
    y: 77.342,
    width: 150.585,
    height: 59.7139,
    rx: 7.5,
    transform: "rotate(-30 2.04904 77.342)",
    stroke: "#00803A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.1732,
    y: 79.7865,
    width: 137.227,
    height: 46.3554,
    rx: 3.5,
    transform: "rotate(-30 11.1732 79.7865)",
    stroke: "#00803A",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.157 52.5098L115.115 51.9567L110.148 43.3543L109.19 43.9074L107.365 40.7461L115.144 36.2551C117.277 35.0236 119.309 34.634 121.239 35.0864C123.174 35.5187 124.902 37.0504 126.421 39.6816C127.94 42.3128 128.406 44.581 127.82 46.4861C127.24 48.3711 125.883 49.9294 123.75 51.1609L115.971 55.6519L114.157 52.5098ZM121.591 48.2179C122.025 47.9672 122.284 47.6642 122.369 47.3089C122.453 46.9537 122.355 46.5333 122.075 46.048L118.734 40.2619C118.189 39.3167 117.482 39.0949 116.613 39.5963L115.502 40.2379L120.48 48.8595L121.591 48.2179Z",
    fill: "#00803A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.008 61.4019L104.194 58.2598L105.152 57.7067L100.174 49.0851L99.2164 49.6382L97.4023 46.4961L104.683 42.2927L106.497 45.4348L105.539 45.9879L110.517 54.6095L111.475 54.0564L113.289 57.1985L106.008 61.4019Z",
    fill: "#00803A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.906 60.1596L101.673 59.7171L103.487 62.8592L95.9764 67.1953L94.1623 64.0532L95.3118 63.3895L94.1204 62.0338L91.5147 63.5382L92.0931 65.2479L93.2427 64.5842L95.0568 67.7263L88.5043 71.5093L86.6902 68.3672L87.4566 67.9248L83.9027 54.2917L90.8766 50.2652L100.906 60.1596ZM90.7637 61.2639L92.5264 60.2463L89.5396 56.8871L89.348 56.9977L90.7637 61.2639Z",
    fill: "#00803A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6902 76.4493L73.6482 75.8962L68.6705 67.2746L67.7125 67.8276L65.8984 64.6855L74.3093 59.8295C75.957 58.8782 77.4216 58.5095 78.7031 58.7233C79.9772 58.9244 81.0715 59.8168 81.986 61.4006C82.9004 62.9844 83.1298 64.3847 82.6742 65.6015C82.2112 66.8054 81.1559 67.883 79.5082 68.8343L77.4199 70.04L79.0128 72.799L80.852 71.7371L82.6661 74.8792L74.5043 79.5914L72.6902 76.4493ZM76.5006 66.9433C77.2414 66.5156 77.3758 65.8931 76.9039 65.0756L76.5056 64.3859C76.2623 63.9644 75.9895 63.7131 75.6873 63.6321C75.3905 63.531 75.0569 63.5874 74.6865 63.8012L74.0351 64.1773L75.8491 67.3194L76.5006 66.9433Z",
    fill: "#00803A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7903 67.258L44.2031 89.124L36.2516 86.894L34.1732 95.028L50.2103 99.5287L57.8759 69.5287L49.7903 67.258Z",
    fill: "#00803A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.7f211e50655a67bdba70618c6bd4ecd8.svg";
export { ForwardRef as ReactComponent };